
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/termsOfUse",
      function () {
        return require("private-next-pages/legal/termsOfUse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/termsOfUse"])
      });
    }
  